<template>
  <ul ref="heightRef">
    <li
      v-for="(option, index) in props.options"
      v-show="!isCollapsed || props.collapsedVisibleCount + 1 === props.options.length || index < props.collapsedVisibleCount"
      :key="`option-${option.id}`"
      :class="{ muted: option.count === 0 }"
      class="flex items-center"
    >
      <CheckboxInput v-model="selectedFilters" :value="option.id" :label="option.name">
        <span class="ml-3.5 inline-flex items-baseline py-1.5" :class="{ 'text-base': props.smallerText, 'text-text-very-light': option.count === 0 }">
          {{ option.name }}
          <span v-if="option.count" class="ml-1 text-xs text-text-disabled">{{ option.count }}</span>
        </span>
      </CheckboxInput>
    </li>
    <li v-if="props.options.length > props.collapsedVisibleCount + 1">
      <button class="py-2 text-text-strong underline hover:no-underline" @click="toggleCollapse">{{ expandButtonLabel }}</button>
    </li>
  </ul>
</template>

<script setup lang="ts">
import CheckboxInput from '~/components/input/CheckboxInput.vue'
import type { ChoiceOption } from './filter'
import * as t from '~/messages'

const props = withDefaults(
  defineProps<{
    title: string
    options: ChoiceOption[]
    group: number
    collapsedVisibleCount?: number
    smallerText?: boolean
    appliedFilters: Choices
  }>(),
  {
    collapsedVisibleCount: 8,
    smallerText: false,
  }
)

interface Choices {
  choices: number[]
}

const isCollapsed = ref(true)
const heightRef = useTemplateRef('heightRef')

const expandButtonLabel = computed(() => {
  if (isCollapsed.value) {
    return t['w.module.filter_bar.show_more']().replace('%s', (props.options.length - props.collapsedVisibleCount).toString())
  }

  return t['w.module.filter_bar.show_less']()
})

const selectedFilters = computed({
  get() {
    return props.appliedFilters.choices.filter((option) => props.options.some((x) => x.id === option))
  },
  set(value) {
    emit('updateChoices', props.group, value)
  },
})

const toggleCollapse = () => {
  isCollapsed.value = !isCollapsed.value

  nextTick(() => {
    const newHeight: number = heightRef.value?.getBoundingClientRect().height ?? 0

    emit('collapseToggled', isCollapsed.value, newHeight)
  })
}

const emit = defineEmits<{
  collapseToggled: [isCollapsed: boolean, newHeight: number]
  updateChoices: [group: number, choices: number[]]
}>()
</script>
